import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

export const sessionSlice = createSlice({
  name: "session",
  initialState: {
    sessions: [],
    session: null,
    mySessions: [],
    messages: [],
    pin: null,
    visitors: 0
  },
  reducers: {
    setSessions: (state, action) => {
      state.sessions = action.payload.sessions;
      state.session = null
    },
    setSession: (state, action) => {
      state.session = action.payload.session
      state.messages = action.payload.session.messages
    },
    setMySessions: (state, action) => {
      state.mySessions = action.payload.sessions;
      state.session = null
    },
    setPin: (state, action) => {
      state.pin = action.payload
    },
    setVisitors: (state, action) => {
      state.visitors = action.payload
    },
    setMessages: (state, action) => {
      const newMessages = [...action.payload.messages, ...state.messages]
      const uniq = _.unionBy(newMessages, 'id')
      const sort = uniq.sort(function compare(a, b) {
        var dateA = new Date(a.created_at);
        var dateB = new Date(b.created_at);
        return dateB - dateA;
      });
      state.messages = sort
    }
  },
});
